import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import moment from "moment"
import marked from "marked"
import Breadcrumb from "../../components/Breadcrumb"
import RegisterProduct from "../RegisterProduct"
import RegisterSerial from "../../components/RegisterSerial"
import RegisterWarranty from "../../components/RegisterWarranty"
import RegisterDate from "../../components/RegisterDate"
import RegisterPurchaseLocation from "../../components/RegisterPurchaseLocation"
import RegisterName from "../../components/RegisterName"
import RegisterAge from "../../components/RegisterAge"
import RegisterOccupation from "../../components/RegisterOccupation"
import RegisterPhone from "../../components/RegisterPhone"
import RegisterEmail from "../../components/RegisterEmail"
import Spinner from "../../components/Spinner"
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import faArrow from "@fortawesome/fontawesome-free-solid/faLongArrowAltRight"
import faTimes from "@fortawesome/fontawesome-free-solid/faTimes"
import faCheck from "@fortawesome/fontawesome-free-solid/faCheckCircle"
import faWarning from "@fortawesome/fontawesome-free-solid/faExclamationCircle"
import RegisterAddress from "../../components/RegisterAddress"
import Config from "../../config/config"
import "./Register.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount"
import { toggleModal } from "../../lib/util"

let registedMsg = {
  success: "已登錄成功",
  failed: "您已登錄完成",
}

const initState = {
  serial: "",
  warranty: "",
  date: new Date(),
  purchase_location_county: "",
  purchase_location_name: "",
  name: "",
        age: "暫不提供",  occupation: "農牧業",
  phone: "",
  email: "",
  address: "",
  product: null,
  validProduct: false,
  validSerial: false,
  validWarranty: false,
  validName: false,
  validLocation: false,
  validPhone: false,
  validEmail: false,
}

class Register extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...initState,
      modalActive: false,
      modalMessage: "",
      modalExtraClass: "",
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleObjectChange = this.handleObjectChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const register_success_message = nextProps.pages.find(
      (p) => p.name === "register_success_message"
    )
    if (register_success_message) {
      registedMsg.success = register_success_message.content
    }

    const register_failed_message = nextProps.pages.find(
      (p) => p.name === "register_failed_message"
    )
    if (register_failed_message) {
      registedMsg.failed = register_failed_message.content
    }
  }

  onDateChange(date) {
    this.setState({
      date,
    })
  }

  handleChange(value, key) {
    this.setState(
      {
        [key]: value,
      },
      () => {
        this.verify()
        console.log(this.state)
      }
    )
  }

  handleObjectChange(paramObj) {
    this.setState(paramObj, () => {
      this.verify()
      console.log(this.state)
    })
  }

  clear = () => {
    console.log("init")
    this.setState({
      ...initState,
    })
  }

  verify = () => {
    let result = {
      validProduct: false,
      validSerial: false,
      validWarranty: false,
      validName: false,
      validLocation: false,
      validPhone: false,
      validEmail: false,
    }

    // product
    result.validProduct = this.state.product

    // email
    const emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    result.validEmail = emailRE.test(String(this.state.email).toLowerCase())

    // phone
    result.validPhone = this.state.phone.length > 0

    // serial
    const serialRE = /^[a-zA-Z0-9]{9}$/
    result.validSerial = serialRE.test(this.state.serial)

    // warranty
    const warrantyRE = /^[a-zA-Z0-9]{8,}$/
    result.validWarranty = warrantyRE.test(this.state.warranty)

    // name
    result.validName = this.state.name.length > 0

    // purchaselocation
    result.validLocation = this.state.purchase_location_name.length > 0
    this.setState(result)
  }

  showNotification = (paramObj) => {
    const { content, extraClass } = paramObj
    // const element = document.getElementById('notification');
    // element.className = 'notification';
    // element.classList.add(extraClass);
    // element.childNodes[1].innerHTML = content;
    // setTimeout(() => {
    //   element.classList.add('is-hidden');
    // }, 3000);

    this.setState({
      modalMessage: content,
      modalExtraClass: extraClass,
    })
  }

  saveCustomer = async () => {
    return fetch(`${Config.apiUrl}/customers`, {
      method: "POST",
      body: JSON.stringify({
        ...this.state,
        product: this.state.product
          ? `${this.state.product.title} ${this.state.product.chinese_title}`
          : "",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        this.showNotification({
          content: "登錄成功",
          extraClass: "is-success",
        })
      })
      .catch((err) => {
        throw err
      })
  }

  findVerification = async () => {
    return fetch(`${Config.apiUrl}/verifications?serial=${this.state.serial}`)
      .then((results) => results.json())
      .then((data) => {
        if (data.length > 0) {
          console.log("verification found")
          return data[0]
        } else {
          console.log("no verification")
          return false
        }
      })
      .catch((err) => {
        throw err
      })
  }

  updateVerification = async (verification) => {
    return fetch(`${Config.apiUrl}/verifications/${verification.id}`, {
      method: "PUT",
      body: JSON.stringify({ registered: true }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        return true
      })
      .catch((err) => {
        throw err
      })
  }

  findEvent = async () => {
    return fetch(`${Config.apiUrl}/events?serial=${this.state.serial}`)
      .then((results) => results.json())
      .then((data) => {
        if (data.length > 0) {
          const now = moment(new Date())
          const validEvents = data.filter((event) => {
            console.log(event)
            let inStart = true
            let inEnd = true
            if (event.end_date) {
              const end_date = moment(event.end_date)
              inEnd = end_date.diff(now) > 0
            }
            if (event.start_date) {
              const start_date = moment(event.start_date)
              inStart = start_date.diff(now) < 0
            }
            return inStart && inEnd
          })
          console.log("event found")
          return validEvents.length > 0 ? validEvents[0] : false
        } else {
          console.log("no event")
          return false
        }
      })
      .catch((err) => {
        throw err
      })
  }

  submit = async () => {
    try {
      if (
        this.state.validName &&
        this.state.validSerial &&
        this.state.validPhone &&
        this.state.validProduct &&
        this.state.validWarranty &&
        this.state.validLocation
      ) {
        const verification = await this.findVerification()
        let msg = verification ? registedMsg.success : registedMsg.failed

        await this.saveCustomer()
        if (verification && !verification.registered) {
          await this.updateVerification(verification)
        }

        const event = await this.findEvent()
        if (event) {
          msg = event.message
        }

        this.showNotification({
          content: msg,
          extraClass: "is-success",
        })
      } else {
        this.showNotification({
          content: "請填寫必填項目",
          extraClass: "is-error",
        })
      }
    } catch (err) {
      console.log(err)
      this.showNotification({
        content: "有些錯誤發生囉，請稍候重試或向網站管理員聯絡",
        extraClass: "is-error",
      })
    }
  }

  toggleModal = () => {
    this.setState(
      {
        modalActive: !this.state.modalActive,
        modalMessage: "",
        modalExtraClass: "",
      },
      () => {
        toggleModal(this.state.modalActive)
        if (this.state.modalActive) {
          this.submit()

          // debug only
          // setTimeout(() => this.setState(
          //   {modalMessage: '有些錯誤發生囉!<BR>請稍候重試或向網站管理員聯絡', modalExtraClass:'is-error'}
          // ), 1000);

          // setTimeout(() => this.setState(
          //   {modalMessage: '成功完成', modalExtraClass:'is-success'}
          // ), 1000);
        } else {
          this.clear()
        }
      }
    )
  }

  check = () => {
    if (!this.state.validProduct) {
      const ele = document.getElementById("register-product-select")
      if (ele) {
        ele.classList.add("text-in-red")
      }
    }
    if (!this.state.validSerial) {
      const ele = document.getElementById("register-serial-input")
      if (ele) {
        ele.classList.add("is-danger")
      }
    }
    if (!this.state.validWarranty) {
      const ele = document.getElementById("register-warranty-input")
      if (ele) {
        ele.classList.add("is-danger")
      }
    }
    if (!this.state.validName) {
      const ele = document.getElementById("register-name-input")
      if (ele) {
        ele.classList.add("is-danger")
      }
    }
    if (!this.state.validPhone) {
      const ele = document.getElementById("register-phone-input")
      if (ele) {
        ele.classList.add("is-danger")
      }
    }
    if (!this.state.validLocation) {
      const ele = document.getElementById("register-location-input")
      if (ele) {
        ele.classList.add("is-danger")
      }
    }

    if (
      this.state.validProduct &&
      this.state.validSerial &&
      this.state.validWarranty &&
      this.state.validName &&
      this.state.validPhone &&
      this.state.validLocation
    ) {
      this.toggleModal()
    }
  }

  render() {
    let modal_purchase = `${this.state.purchase_location_county} ${this.state.purchase_location_name}`
    if (modal_purchase.trim().length === 0) {
      modal_purchase = "無"
    }

    return (
      <section className="section">
        <ScrollToTopOnMount />
        <div className="register container">
          <Breadcrumb {...this.props} />

          <div className="outter-container">
            <div className="inner-container register-inner-container">
              <div className="columns">
                <div className="column column-left">
                  <RegisterProduct
                    categories={this.props.categories}
                    products={this.props.products}
                    handleObjectChange={this.handleObjectChange}
                    product={this.state.product}
                  />
                  <RegisterSerial
                    handleChange={this.handleChange}
                    serial={this.state.serial}
                    valid={this.state.validSerial}
                  />
                  <RegisterWarranty
                    handleChange={this.handleChange}
                    warranty={this.state.warranty}
                    valid={this.state.validWarranty}
                  />
                  <RegisterDate
                    handleObjectChange={this.handleObjectChange}
                    date={this.state.date}
                  />
                  <RegisterPurchaseLocation
                    handleObjectChange={this.handleObjectChange}
                    country={this.state.purchase_location_county}
                    name={this.state.purchase_location_name}
                    valid={this.state.validLocation}
                  />

                  <RegisterOccupation
                    handleChange={this.handleChange}
                    occupation={this.state.occupation}
                  />
                </div>

                <div className="column column-right">
                  <RegisterAge
                    handleChange={this.handleChange}
                    age={this.state.age}
                  />
                  <RegisterEmail
                    handleChange={this.handleChange}
                    email={this.state.email}
                    valid={this.state.validEmail}
                  />
                  <RegisterName
                    handleChange={this.handleChange}
                    name={this.state.name}
                    valid={this.state.validName}
                  />
                  <RegisterPhone
                    handleChange={this.handleChange}
                    phone={this.state.phone}
                    valid={this.state.validPhone}
                  />
                  <RegisterAddress
                    handleObjectChange={this.handleObjectChange}
                    name={this.state.address}
                  />
                </div>
              </div>

              <div className="register-footer">
                <div className="App-skew-more-button" onClick={this.check}>
                  <div>登錄</div>
                  <FontAwesomeIcon
                    className="App-skew-more-button-arrow"
                    icon={faArrow}
                  />
                </div>
              </div>
              <div className="notification is-hidden" id="notification">
                <button
                  className="delete"
                  onClick={(event) => {
                    event.target.parentNode.classList.add("is-hidden")
                  }}
                />
                <p className="notification-content" />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal register-modal ${
            this.state.modalActive ? "is-active" : ""
          }`}
        >
          <div className="modal-background" onClick={this.toggleModal} />
          <div className="modal-content">
            <div className="card">
              <button
                className="card-close"
                aria-label="close"
                onClick={this.toggleModal}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
              <div className="card-content">
                <div
                  className={`card-content-body ${this.state.modalExtraClass}`}
                >
                  {/*<div className="register-title">產品登錄</div>*/}
                  {/*
                  <div className="register-content">
                    <div className="register-content-columns">
                      <div className="register-content-column">
                        <div className="register-content-row">
                          <div className="register-content-label">購買產品</div>
                          <div className="register-content-value">{this.state.product ? `${this.state.product.title} ${this.state.product.chinese_title}` : "無"}</div>
                        </div>
                        <div className="register-content-row">
                          <div className="register-content-label">產品序號</div>
                          <div className="register-content-value">{this.state.serial.length > 0 ? this.state.serial : "無"}</div>
                        </div>
                        <div className="register-content-row">
                          <div className="register-content-label">購買日期</div>
                          <div className="register-content-value">{this.state.date ? moment(this.state.date).format('YYYY-MM-DD') : "無"}</div>
                        </div>
                        <div className="register-content-row">
                          <div className="register-content-label">購買地點</div>
                          <div className="register-content-value">{modal_purchase}</div>
                        </div>
                        <div className="register-content-row">
                          <div className="register-content-label">購買人姓名</div>
                          <div className="register-content-value">{this.state.name.length > 0 ? this.state.name : "無"}</div>
                        </div>
                      </div>
                      <div className="register-content-column">
                        <div className="register-content-row">
                          <div className="register-content-label">購買人年齡</div>
                          <div className="register-content-value">{this.state.age.length > 0 ? this.state.age : "無"}</div>
                        </div>
                        <div className="register-content-row">
                          <div className="register-content-label">購買人職業</div>
                          <div className="register-content-value">{this.state.occupation.length > 0 ? this.state.occupation : "無"}</div>
                        </div>
                        <div className="register-content-row">
                          <div className="register-content-label">購買人手機(電話)</div>
                          <div className="register-content-value">{this.state.phone.length > 0 ? this.state.phone : "無"}</div>
                        </div>
                        <div className="register-content-row">
                          <div className="register-content-label">購買人電子信箱</div>
                          <div className="register-content-value">{this.state.email.length > 0 ? this.state.email : "無"}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  */}
                  {!this.state.modalMessage && <Spinner />}
                  {this.state.modalExtraClass === "is-success" && (
                    <FontAwesomeIcon
                      className={`modal-message-icon ${this.state.modalExtraClass}`}
                      size="2x"
                      icon={faCheck}
                    />
                  )}
                  {this.state.modalExtraClass === "is-error" && (
                    <FontAwesomeIcon
                      className={`modal-message-icon ${this.state.modalExtraClass}`}
                      size="2x"
                      icon={faWarning}
                    />
                  )}
                  {this.state.modalMessage && (
                    <div
                      className="register-modal-message"
                      dangerouslySetInnerHTML={{
                        __html: marked(this.state.modalMessage),
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <button
            className="modal-close is-large"
            aria-label="close"
            onClick={this.toggleModal}
          />
        </div>
      </section>
    )
  }
}

Register.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const mapStateToProps = (state) => ({
  categories: state.categories,
  products: state.products,
  pages: state.pages,
})

export default connect(mapStateToProps)(Register)



// WEBPACK FOOTER //
// ./src/containers/page/Register.js